<template>
    <div class="loading-skeleton-container">
        <div class="loading-skeleton image"></div>
        <div class="content">
            <div class="loading-skeleton --slim-margin --subheadline --full-width"></div>
            <div class="loading-skeleton --slim-margin --line --full-width"></div>
            <div class="loading-skeleton --slim-margin --subheadline --full-width"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @import '~/assets/scss/basics/loading-skeleton.scss';

    .loading-skeleton-container {
        display: flex;
        gap: $spacing;

        .image {
            display: flex;
            width: 25%;
            aspect-ratio: 1 / 1;
        }

        .content {
            display: flex;
            flex-direction: column;
            width: 75%;
        }
    }
</style>
